import useDesign from "../useDesign";
import LandingA from "./a/LandingA";
import LandingB from "./b/LandingB";
import LandingC from "./c/LandingC";
import type { LandingData } from "./types";

const LANDINGS = { a: LandingA, b: LandingB, c: LandingC };

export default function Landing({ data }: { data: LandingData }) {
  const Page = LANDINGS[useDesign()];
  return <Page data={data} />;
}
